import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { ordersApi } from '../api';

function CartPage() {
  const { items, removeItem, updateQty, clear, total } = useCart();
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleOrder = async () => {
    const token = localStorage.getItem('token');
    if (!token) { navigate('/login'); return; }

    setLoading(true); setError('');
    try {
      await ordersApi.create(
        items.map(i => ({ product_id: i.id, quantity: i.qty })),
        comment
      );
      clear();
      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const s = {
    page: { minHeight: '100vh', background: '#F8F6F0', padding: '80px 40px 40px' },
    container: { maxWidth: 900, margin: '0 auto' },
    title: { fontFamily: 'Georgia, serif', fontSize: 32, fontWeight: 700, color: '#0D1B2A', marginBottom: 32 },
    card: { background: '#fff', borderRadius: 12, border: '1px solid #E2DECE', padding: 32, marginBottom: 24 },
    row: { display: 'flex', alignItems: 'center', gap: 16, padding: '16px 0', borderBottom: '1px solid #F1F1EF' },
    name: { flex: 1, fontSize: 14, fontWeight: 500, color: '#0D1B2A' },
    qty: { display: 'flex', alignItems: 'center', gap: 8 },
    qtyBtn: { width: 32, height: 32, border: '1px solid #E2DECE', background: '#fff', borderRadius: 6, cursor: 'pointer', fontSize: 16 },
    qtyNum: { width: 40, textAlign: 'center', fontSize: 14, fontWeight: 600 },
    price: { fontSize: 14, fontWeight: 600, color: '#0D1B2A', minWidth: 80, textAlign: 'right' },
    removeBtn: { background: 'none', border: 'none', cursor: 'pointer', color: '#6B7280', fontSize: 18 },
    total: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 0 0' },
    totalLabel: { fontSize: 16, fontWeight: 600, color: '#0D1B2A' },
    totalPrice: { fontSize: 24, fontWeight: 700, color: '#0D1B2A' },
    textarea: { width: '100%', padding: '12px 16px', border: '1px solid #E2DECE', borderRadius: 8, fontSize: 14, height: 80, resize: 'vertical', boxSizing: 'border-box', fontFamily: 'Inter, sans-serif', marginBottom: 16 },
    btn: { width: '100%', padding: 14, background: '#0D1B2A', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: 'pointer' },
    empty: { textAlign: 'center', padding: 64, color: '#6B7280' },
    error: { background: '#FEE2E2', color: '#991B1B', padding: '12px 16px', borderRadius: 8, fontSize: 13, marginTop: 12 },
  };

  if (success) return (
    <div style={s.page}>
      <div style={{...s.container, textAlign:'center', paddingTop: 80}}>
        <div style={{fontSize: 64, marginBottom: 16}}>🎉</div>
        <h2 style={{fontFamily:'Georgia,serif', fontSize:28, color:'#0D1B2A', marginBottom:8}}>Замовлення прийнято!</h2>
        <p style={{color:'#6B7280', marginBottom:32}}>Менеджер зв'яжеться з вами найближчим часом</p>
        <button style={{...s.btn, width:'auto', padding:'12px 32px'}} onClick={() => navigate('/catalog')}>Продовжити покупки</button>
      </div>
    </div>
  );

  return (
    <div style={s.page}>
      <div style={s.container}>
        <h1 style={s.title}>Кошик</h1>

        {items.length === 0 ? (
          <div style={s.empty}>
            <div style={{fontSize:48, marginBottom:12}}>🛒</div>
            <div style={{marginBottom:16}}>Кошик порожній</div>
            <button style={{...s.btn, width:'auto', padding:'12px 32px'}} onClick={() => navigate('/catalog')}>До каталогу</button>
          </div>
        ) : (
          <>
            <div style={s.card}>
              {items.map(item => (
                <div key={item.id} style={s.row}>
                  <div style={s.name}>
                    <div>{item.name}</div>
                    <div style={{fontSize:12, color:'#6B7280', marginTop:2}}>{item.brand} · {item.qty_per_box}</div>
                  </div>
                  <div style={s.qty}>
                    <button style={s.qtyBtn} onClick={() => updateQty(item.id, item.qty - 1)}>−</button>
                    <span style={s.qtyNum}>{item.qty}</span>
                    <button
                      style={s.qtyBtn}
                      onClick={() => {
                        const max = item.quantity_in_stock;
                        if (max !== null && max !== undefined && item.qty >= max) return;
                        updateQty(item.id, item.qty + 1);
                      }}
                    >+</button>
                  </div>
                  <div style={s.price}>{(item.price * item.qty).toLocaleString()} ₴</div>
                  <button style={s.removeBtn} onClick={() => removeItem(item.id)}>✕</button>
                </div>
              ))}
              <div style={s.total}>
                <span style={s.totalLabel}>Разом:</span>
                <span style={s.totalPrice}>{total.toLocaleString()} ₴</span>
              </div>
            </div>

            <div style={s.card}>
              <div style={{fontSize:16, fontWeight:600, color:'#0D1B2A', marginBottom:16}}>Коментар до замовлення</div>
              <textarea style={s.textarea} placeholder="Побажання, уточнення щодо доставки..." value={comment} onChange={e => setComment(e.target.value)} />
              <button style={s.btn} onClick={handleOrder} disabled={loading}>
                {loading ? 'Відправляємо...' : 'Оформити замовлення'}
              </button>
              {error && <div style={s.error}>{error}</div>}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default CartPage;
